export enum LoraStatusEnum {
  draft = "draft",
  training = "training",
  published = "published",
  unpublished = "unpublished",
  erroneous = "erroneous",
}
